import { BaseProvider } from "./base.provider";

export interface LlmCostEntry {
  model: string;
  call_count: number;
  total_input_tokens: number;
  total_output_tokens: number;
  total_thoughts_tokens: number;
  /** Estimated cost. 0 can mean "actually free" or "couldn't be priced" — check call_count. */
  total_cost_usd: number;
}

export interface InfraCostAggregate {
  /** Gemini usage (event badge-image generation), grouped by model. */
  llm_costs: LlmCostEntry[];
  /** Safety-moderation usage, grouped by model. Mixes OpenRouter slugs (e.g. qwen/qwen3.7-flash, priced live off their catalog) and jev model ids (e.g. jev-1.13, priced at jev's fixed rate). total_thoughts_tokens is always 0. */
  moderation_costs: LlmCostEntry[];
}

class CostsProvider extends BaseProvider {
  getCosts(params?: { from?: Date; to?: Date }): Promise<InfraCostAggregate> {
    const q = new URLSearchParams();
    if (params?.from) q.set("from", params.from.toISOString());
    if (params?.to) q.set("to", params.to.toISOString());
    const qs = q.toString();
    return this.request<InfraCostAggregate>(
      `/v1/admin/costs${qs ? `?${qs}` : ""}`,
    );
  }
}

export const costsProvider = new CostsProvider();
